<div id="print-section" style="font-size: 12px" [hidden]="true">
    <div class="row">
        <div class="col-24">
            <div>
                <!--<div class="logo"></div>-->
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-24">

            <table style="width: 100%; font-family: Helvetica, Arial, sans-serif;font-size: 13px;">
                <tbody>
                    <tr style="text-align:center; margin-bottom:50px;">
                        <th colspan="2" style="text-align:center;border-bottom:0px">Thank You</th>                     
                    </tr>
                    
                    <tr style="border:0px">                       
                        <td style="font-weight:bold; border-right:0px">Online Enrollment Confirmation #</td>
                        <td>
                            {{confirmationNumber}}
                        </td>
                    </tr>
                    <tr *ngFor="let enrol of enrollmentJson.EnrollmentFields">
                        <td style="font-weight:bold">{{enrol.FieldCode}}</td>
                        <td>{{enrol.FieldValue}}</td>
                    </tr>
                </tbody>
            </table>

        </div>

    </div>
    <div class="row">
        <div class="col-24" style="font-size: 12px">
            <div>
                <h2>
                    Terms of Enrollment
                </h2>
                <p>
                    <strong>By completing this enrollment application, I agree to the following:</strong>
                </p>
                <p>
                    {{ICNAME}} offers two Medicare drug plans and has a contract with the Federal government.
                    I understand that this prescription drug coverage is in addition to my coverage under Medicare; therefore,
                    I will need to keep my Medicare Part A or Part B coverage. It is my responsibility to inform {{ICNAME}} of any prescription drug coverage that I have or may get in the future. I can only
                    be in one Medicare prescription drug plan at a time – if I am currently in a Medicare prescription drug
                    plan, my enrollment in {{ICNAME}} will end that enrollment. Enrollment in this plan
                    is generally for the entire year. Once I enroll, I may leave this plan or make changes if an enrollment
                    period is available, generally during the Annual Enrollment period (October 15 – December 7), unless
                    I qualify for certain special circumstances.
                </p>
                <p>
                    {{ICNAME}} serves a specific service area. If I move out of the area that {{ICNAME}} serves, I need to notify the plan so I can disenroll and find a new plan in my new
                    area. I understand that I must use network pharmacies except in an emergency when I cannot reasonably
                    use {{ICNAME}} network pharmacies. Once I am a member of {{ICNAME}}, I have the right to appeal plan decisions about payment or services if I disagree. I will read
                    the Evidence of Coverage document from {{ICNAME}} when I get it to know which rules
                    I must follow to get coverage.
                </p>
                <p>
                    I understand that if I leave this plan and don’t have or get other Medicare prescription drug coverage
                    or creditable prescription drug coverage (as good as Medicare’s), I may have to pay a late enrollment
                    penalty in addition to my premium for Medicare prescription drug coverage in the future.
                </p>
                <p>
                    I understand that if I am getting assistance from a sales agent, broker, or other individual employed
                    by or contracted with {{ICNAME}}, he/she may be paid based on my enrollment in {{ICNAME}}. Counseling services may be available in my state to provide advice concerning Medicare
                    supplement insurance or other Medicare Advantage or Prescription Drug Plan options, medical assistance
                    through the state Medicaid program and the Medicare Savings Program.
                </p>
                <h3>
                    <b> Release of Information:</b>
                </h3>
                <p>
                    By joining this Medicare Prescription Drug Plan, I acknowledge that {{ICNAME}} will
                    release my information to Medicare and other plans as is necessary for treatment, payment and health
                    care operations. I also acknowledge that {{ICNAME}} will release my information,
                    including my prescription drug event data, to Medicare, who may release it for research and other purposes
                    which follow all applicable federal statutes and regulations. The information on this enrollment form
                    is correct to the best of my knowledge. I understand that if I intentionally provide false information
                    on this form, I will be disenrolled from the plan.
                </p>
                <p>
                    I understand that my signature (or the signature of the person authorized to act on my behalf under
                    State law where I live) on this application means that I have read and understand the contents of this
                    application. If signed by an authorized individual (as described above), this signature certifies that:<br />
                    1) this person is authorized under State law to complete this enrollment and <br />
                    2) documentation of this authority is available upon request by {{ICNAME}} or by Medicare.
                </p>
                <p>
                    <strong>
                        By clicking the button below, the applicant certifies that the applicant has read, understands and
                        agrees to the terms of enrollment and wishes to enroll with {{ICNAME}}
                    </strong>
                </p>
                <br />

                <p style="text-align:center;padding-bottom:50px">
                    <b>
                        Please sign below to certify that you have read, understand and<br />
                        agree to the conditions written above.
                    </b>
                    <br />
                </p>

                <div>
                    <div style="width:40%; float:left;border-top:solid 1px black; margin-right:10%">
                        <p style="text-align:right"><span class="signature">(Applicant's Signature)</span></p>
                    </div>
                    <div style="width:40%; float:right;border-top:solid 1px black;margin-right:10%">
                        <p style="text-align:right"><span class="date">(Date)</span></p>
                    </div>
                </div>

                <div>
                    <div style="width:40%; float:left;border-top:solid 1px black; margin-right:10%">
                        <p style="text-align:right"><span class="signature">(Agent's Signature)</span></p>
                    </div>
                    <div style="width:40%; float:right;border-top:solid 1px black;margin-right:10%">
                        <p style="text-align:right"><span class="date">(Date)</span></p>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>